import { useQuery } from '@tanstack/react-query';

import { Subscriptions } from '@air/api';

import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';
import { canManageSubscription } from '~/utils/permissions/workspacePermissions';

export const SUBSCRIPTION_UPCOMING_INVOICE = 'SUBSCRIPTION_UPCOMING_INVOICE';

export const getSubscriptionUpcomingInvoiceKey = (workspaceId?: string) => {
  return workspaceId ? [SUBSCRIPTION_UPCOMING_INVOICE, { workspaceId }] : [SUBSCRIPTION_UPCOMING_INVOICE];
};

export const useUpcomingInvoice = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
  const { data: subscription } = useSubscriptionContext();
  const planId = subscription?.planId;

  return useQuery({
    queryKey: getSubscriptionUpcomingInvoiceKey(workspaceId),

    queryFn: async () => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      const upcomingInvoice = await Subscriptions.retrieveUpcomingInvoice({ workspaceId });
      // Backend returns 204 - No Content when there is no upcoming invoice. react-query doesn't like undefined responses.
      // See https://github.com/TanStack/query/discussions/6380
      return upcomingInvoice ?? null;
    },
    enabled: !!workspaceId && !!planId && canManageSubscription(workspacePermissions),
  });
};
